<template>
	<div class="add-sub container-fluid">
		<div class="row">
			<div class="block highlighted-content">
				<!-- <p class="text-uppercase">{{ 'Complexity' | translate }}</p> -->

				<div class="complexity-list text-center">
					<div class="complexity" :class="{ active: digit == 50 }" @click="digit = 50">
						50
					</div>

					<div class="complexity" :class="{ active: digit == 100 }" @click="digit = 100">
						100
					</div>
				</div>

				<fieldset class="digits-field base">
					<label>
						<input type="radio" value="more_than_digit" v-model="mode" />
						> {{ digit }}
					</label>

					<label>
						<input type="radio" value="less_than_digit" v-model="mode" />
						&lt; {{ digit }}
					</label>

					<label>
						<input type="radio" value="universal" v-model="mode" />

						<a class="not-equal">{{ digit }}</a>
					</label>
				</fieldset>

				<div>
					<button @click="startGame" class="text-uppercase btn btn-success">
						{{ 'Start' | translate }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'multiply-base',
	data() {
		return {
			digit: 50,
			mode: 'more_than_digit',
		}
	},
	computed: {
		isCustomBgEnabled() {
			return !!this.$store.getters.primaryBackground
		},
	},
	methods: {
		startGame(complexity) {
			let data = {
				type: 'multiply_50_100',
				digit: this.digit,
				mode: this.mode,
				withSound: false,
			}
			this.$store.commit('changeGameConfig', data)
			this.$router.push({ path: '/games/game' })
		},
	},
}
</script>

<style scoped lang="scss">
.not-equal::before {
	content: '\2260';

	margin: 0 4px;

	font-family: 'Times New Roman', Times, serif;
}

.digits-field.base {
	display: flex;
	flex-direction: column;

	padding: 25px 34px;

	width: 100%;
}

.complexity {
	margin: 2px;
}

.setting {
	text-align: center;
	text-transform: uppercase;
}

.btn-secondary {
	width: 150px;
	display: block;
	margin: 15px auto;
}

.btn-pink {
	background-color: #e4467b;
	color: #fff;
	height: 50px;
	line-height: 2;
	margin: 10px 15px;
	cursor: pointer;
	width: 150px;
}

.btn-pink:hover {
	background-color: #e85183;
}

.block {
	display: flex;
	flex-direction: column;
	// grid-template-columns: 40% 60%;
	// grid-gap: 15px;
	// text-align: center;

	width: fit-content;
	padding: 30px;
	margin: auto;

	&.highlighted-content {
		background: #fff;
		border-radius: 12px;
		// border: 2px solid red;
		color: #212529;

		box-shadow: 0px 15px 30px rgba(20, 35, 62, 0.15);
	}

	& h6 {
		margin: 0;
	}

	@media (max-width: 767px) {
		display: block;
		text-align: center;
	}
}
</style>
